// extracted by mini-css-extract-plugin
module.exports = {"body":"y7fuCwZ60xA6PmA-m9TqI","outletTable":"_3pamSs7NPjKMJwceS0w6F0","checkboxCol":"_2oAiWzAC1Kptz0fRyZ_N5Y","footer":"_1Aw2gTKdQGlvg7Yj5TLb43"};